export * from './desktop-content-block';
